import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../Containers/ContainerCreate";
import { getGenreList } from "../../api/getGenre";

class GenreSearchResultsContainer extends React.Component {
  componentDidMount() {
    this.props.defaultState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    if (this.props.terms !== prevProps.terms) {
      this.props.request(this.props.terms, "");
    }
    if (this.props.letter !== prevProps.letter) {
      this.props.request("", this.props.letter);
    }
  }
  chunk(arr, cols) {
    var res = [];
    let n = Math.ceil(arr.length / cols);
    while (arr.length) {
      res.push(arr.splice(0, n));
    }

    return res;
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const genres = (data && data.data) || {};
    const genres_chunked = this.chunk(genres, 3);
    return render({ genres_chunked, loading, failure });
  };
}

GenreSearchResultsContainer.propTypes = {
  letter: PropTypes.string,
  terms: PropTypes.string
};

GenreSearchResultsContainer.defaultProps = {
  letter: "",
  terms: ""
};

export default CreateContainer(getGenreList, GenreSearchResultsContainer);
